var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.bannerMatchingCurrentPath)?_c('div',{staticClass:"one-listing-banner mb-2",domProps:{"innerHTML":_vm._s(_vm.bannerMatchingCurrentPath.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }